export const SidebarNavIconVariants = Object.freeze({
    Base: 'base',
    Sub: 'sub'
});

export type SidebarNavIconVariant = (typeof SidebarNavIconVariants)[keyof typeof SidebarNavIconVariants];
